module.exports = __webpack_public_path__ + "media/components/assets/img/bg/airplane-light-418a99192649cdb5703bf615779182c0.svg";